import clsx from "clsx";
import PropTypes from "prop-types";

import "./zero-state-message.scss";

export const ZeroStateMessage = ({
  message,
  icon,
  onClick,
  disabled,
  className,
}) => {
  return (
    <div
      className={clsx(
        "zero-state-message",
        "clickable" && onClick && !disabled,
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <div className="zero-state-message-icon">{icon}</div>}
      <div className="zero-state-message-content">{message}</div>
    </div>
  );
};

ZeroStateMessage.propTypes = {
  message: PropTypes.node.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
